export default __webpack_public_path__ + "static/media/V250_B_BD.02514eee.pdf";